<template>
  <div class="graph-container">
    <header><slot name="title"></slot></header>
    <div class="d-flex justify-content-between align-items-center">
      <div ref="graph" class="graph w-100"></div>
    </div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BaseGraph from "./_BaseGraph";

am4core.useTheme(am4themes_animated);

export default {
  extends: BaseGraph,
  methods: {
    buildGraph () {
      if (this.data) {
        let chart = am4core.create(this.$refs.graph, am4charts.RadarChart);

        am4core.options.commercialLicense = true;
        chart.data = this.data;

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = this.fields.category;
        categoryAxis.renderer.labels.template.fontSize = 12;
        categoryAxis.renderer.labels.template.fontWeight = 400;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.gridType = "polygons";
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.renderer.labels.template.fontWeight = 400;

        let series = chart.series.push(new am4charts.RadarSeries());
        series.dataFields.valueY = this.fields.value;
        series.dataFields.categoryX = this.fields.category;
        series.strokeWidth = 3;
        series.fillOpacity = 0.2;

        this.chart = chart
      }
    }
  }
};
</script>
<style scoped>
.graph {
  width: 300px;
}
.label {
  display: flex;
  align-items: center;
  font-size: .75rem;
  width: 100%;
}
.label-color {
  display: inline-block;
  height: .75rem;
  width: .75rem;
  border-radius: 3px;
}
.label-value {
  margin-left: auto;
}
</style>
